package com.appsyde.shared.network

import kotlinx.serialization.Serializable

@Serializable
data class SessionResponse(val connected: Boolean)